//=============================================================================
//  コード定義
//=============================================================================
export const JOB_CATEGORY_CODE_OFC = "310";
export const JOB_CATEGORY_CODE_DM = "210";
export const JOB_CATEGORY_CODE_ZM = "120";
export const JOB_CATEGORY_CODE_ZM_JOHO = "316";
const JOB_CATEGORY_CODE_GM = "101";
const JOB_CATEGORY_CODE_MGR = "230";
const JOB_CATEGORY_CODE_RFC = "360";

//=============================================================================
//  権限
//=============================================================================
//  許可職種判定
export const isAcceptJob = (jobCategory: string) => {
  return jobCategory === "ofc" || jobCategory === "dm";
};

//  管理職判定
export const isMagager = (jobCategory: string) => {
  return (
    jobCategory === "admin-group" ||
    jobCategory === "ops" ||
    jobCategory === "gm" ||
    jobCategory === "zm"
  );
};

/** リクルート本部 */
const requrltDeptCodes = [
  "950100",
  "950124",
  "950134",
  "950136",
  "950200",
  "950201",
  "950205",
  "950206",
  "950300",
  "950301",
  "950316",
  "950317",
  "950400",
  "950401",
  "950402",
  "950404",
  "950405",
  "950500",
  "950501",
  "950506",
  "950507",
  "950509",
  "950600",
  "950601",
  "950604",
  "950607",
  "950650",
  "950651",
  "950652",
  "950653",
  "950659",
  "950660",
  "950665",
  "950666",
  "950667",
  "950668",
  "950670",
  "950671",
  "950672",
  "950673",
  "950674",
  "950680",
  "950681",
  "950682",
  "950683",
  "950K00",
  "950K11",
  "950K12",
];

/** TR権限 （現在未使用、そのうち削除予定）*/
const trDeptCodes:any = [];
/** 地域共生（ゾーン担当） */
const chiikikyoseiZoDeptCodes = [
  "900A71",
  "900A72",
  "900A73",
  "900A74",
  "900A75",
  "900A76",
  "900A77",
  "900A78",
  "900A79",
  "900A80",
  "900A81",
  "900A82",
  "900A83",
  "900A84",
  "900A85",
  "900A86",
  "900A87",
  "900A88",
  "900A89",
  "900A90",
];
/** 地域共生（本部、免許管理） */
const chiikikyoseiZenkokuDeptCodes = [
  "900A70",
  "900A91",
];

/** 教育推進 */
const kyoikuSuishinDeptCode = "954200";
/** 社員研修 */
const shainkenshuDeptCode = "954202";
/** TR全国閲覧可能部署 */
const TRCode = ["954210", "954220", "954230"]
/** 教育推進、社員研修、TR部署（全国権限） */
const kyoikuSuishinDeptCodes = [kyoikuSuishinDeptCode, shainkenshuDeptCode, ...TRCode];
/** OP企画 */
const opKikakuDeptCode = "900A50";
/** OP支援 */
const opShienDeptCode = "900A20";
/** OP情報 */
const opJohoDeptCode = "900A60";
/** システム企画-ビジネス企画 */
const systemKikakuDeptCode = ["955502"];
/** リクルート法人など 全参照できる権限コード*/
const recruitReadAllDeptCode =["950700", "950710", "950720", "950900", "950907", "950921"];

/** 建築設備本部_管理部 */
const kentikuKanriDeptCode = ["953400", "953402", "953404", "953405"];

/** ＦＦ・店舗品質管理 */
const qualityControlDeptCode = ["952103"];

/** 沖縄_社長 */
const okinawaPresidentDeptCode = "966090";

/** 監査室 */
const kansashitsuDeptCodes = ["962000", "962001", "962002"];

/** リクルートリサーチ */
const recruitResearchDeptCode = ["950001"];

/** 個別Adminユーザー(メールアドレス)*/
const adminUserList = [
  "nagata-tatsuji@sej.7andi.co.jp",
];

/** 個別Adminユーザー(メールアドレス) テンプレート*/
const adminUserChecKTemplateList = [
  "abe-hiroyuki@sej.7andi.co.jp",
  "nakahashi-yuusuke@sej.7andi.co.jp",
  "nogami-akira@sej.7andi.co.jp",
  "kihara-kengo@sej.7andi.co.jp",
  "nishimura-izuru@hd.7andi.co.jp",
  "j-itou@hd.7andi.co.jp",
  "miyashita-makiko@hd.7andi.co.jp",
  "atsumi-kumiko@hd.7andi.co.jp",
  "takayanagi-masanori@sej.7andi.co.jp",
  "hayashi-yoshitaka@sej.7andi.co.jp",
  "oohira-kazuyuki@sej.7andi.co.jp",
  "miyazaki-atsushi@sej.7andi.co.jp",
];

/** 役員以上の職種コード、GM */
const sevenviewOfficerJobCodeArray = [
  "012",
  "013",
  "014",
  "015",
  "016",
  "017",
  "018",
  "019",
  "050",
  "090",
  "101",
  "110",
];

/** 登録画面表示権限 */
export const isOpenRegistPage = (user: any) => {
  if (
    trDeptCodes.includes(user.departmentCodeOA) ||
    isRecruitDept(user.departmentCodeOA, user.jobCategoryCodeOA)
  ) {
    return false;
  }
  if (kyoikuSuishinDeptCodes.includes(user.departmentCodeOA)) {
    return false;
  } else if (
    isOfcUserCheck(user) ||
    isDmCheck(user) ||
    (isZmCheck(user) &&
      user.jobCategoryCodeOA !== JOB_CATEGORY_CODE_ZM_JOHO &&
      !chiikikyoseiZoDeptCodes.includes(user.departmentCodeOA))
  ) {
    return true;
  } else {
    return false;
  }
};

/** 提出状況確認画面表示権限 */
export const isOpenStatusConfirmPage = (user: any) => {
  if (
    trDeptCodes.includes(user.departmentCodeOA) ||
    isRecruitDept(user.departmentCodeOA, user.jobCategoryCodeOA)
  ) {
    return false;
  }
  if (
    isAdminCheck(user) ||
    user.jobCategory === "gm" ||
    user.jobCategory === "ops" ||
    isZmCheck(user) ||
    isDmCheck(user) ||
    isKyoikusuishinShainkenshuDept(user.departmentCodeOA) ||
    isKentikuKanriDept(user.departmentCodeOA)
  ) {
    return true;
  } else {
    return false;
  }
};

/** 管理者分析画面表示権限 */
export const isOpenManagerAnalysisPage = (user: any) => {
  if (
    trDeptCodes.includes(user.departmentCodeOA) ||
    isRecruitDept(user.departmentCodeOA, user.jobCategoryCodeOA)
  ) {
    return false;
  }
  if (
    isAdminCheck(user) ||
    user.jobCategory === "gm" ||
    user.jobCategory === "ops" ||
    isZmCheck(user) ||
    isDmCheck(user) ||
    isKyoikusuishinShainkenshuDept(user.departmentCodeOA) ||
    isKentikuKanriDept(user.departmentCodeOA)||
    isQcDept(user.departmentCodeOA)
  ) {
    return true;
  } else {
    return false;
  }
};

/** 教育推進TRチェック */
export const isTRDept = (departmentCodeOA: string) => {
  if (trDeptCodes.includes(departmentCodeOA)) {
    return true;
  }
  return false;
};

/** 教育推進、社員研修チェック */
export const isKyoikusuishinShainkenshuDept = (departmentCodeOA: string) => {
  return kyoikuSuishinDeptCodes.includes(
    departmentCodeOA
  );
};

/** 建築設備管理部チェック */
export const isKentikuKanriDept = (departmentCodeOA: string) => {
  return kentikuKanriDeptCode.includes(departmentCodeOA);
};

/** 店舗品質管理部チェック */
export const isQcDept = (departmentCodeOA: string) => {
  return qualityControlDeptCode.includes(departmentCodeOA);
};

/** リクルートチェック */
export const isRecruitDept = (departmentCodeOA: string, jobCode: string) => {
  let targetJobCodes = [JOB_CATEGORY_CODE_MGR, JOB_CATEGORY_CODE_RFC];
  if (
    requrltDeptCodes.includes(departmentCodeOA) &&
    targetJobCodes.includes(jobCode)
  ) {
    return true;
  }
  return false;
};

/**
 * ローカル環境判定。
 */
export const isLocal = () => {
  return window.location.origin.indexOf("localhost") !== -1;
};

/** 評価CSV出力権限 */
export const isDownloadPointData = (user: any) => {
  const csvDownloadableDeptCodes = [
    opKikakuDeptCode,
    opJohoDeptCode,
    opShienDeptCode,
  ];
  csvDownloadableDeptCodes.push(...systemKikakuDeptCode, ...recruitReadAllDeptCode, ...chiikikyoseiZenkokuDeptCodes, ...kansashitsuDeptCodes, ...recruitResearchDeptCode);
  const ownerSoudanDeptCodes = ["960000"];
  const zmJobCode = [JOB_CATEGORY_CODE_ZM, JOB_CATEGORY_CODE_ZM_JOHO];

  if (
    csvDownloadableDeptCodes.includes(user.departmentCodeOA) ||
    kyoikuSuishinDeptCodes.includes(user.departmentCodeOA) ||
    ownerSoudanDeptCodes.includes(user.departmentCodeOA) ||
    zmJobCode.includes(user.jobCategoryCodeOA) ||
    sevenviewOfficerJobCodeArray.includes(user.jobCategoryCodeOA) ||
    isKentikuKanriDept(user.departmentCodeOA)||
    isQcDept(user.departmentCodeOA) ||
    adminUserChecKTemplateList.includes(user.mailAddress) ||
    adminUserList.includes(user.mailAddress)
  ) {
    return true;
  } else {
    return false;
  }
};

/**
 * AdiminGroupチェック
 * @param user
 * @returns
 */
export const isAdminCheck = (user: any) => {
  return isAdminCheckByElement(
    user.jobCategoryCodeOA,
    user.departmentCodeOA,
    user.mailAddress
  );
};

/**
 * AdiminGroupチェック(要素)
 * @param jobCategoryCodeOA
 * @param departmentCodeOA
 * @param mailAddress
 * @returns
 */
export const isAdminCheckByElement = (
  jobCategoryCodeOA: string,
  departmentCodeOA: string,
  mailAddress: string
) => {
  const departmentCodeList = [
    opKikakuDeptCode,
    opShienDeptCode,
    opJohoDeptCode,
  ];
  departmentCodeList.push(...systemKikakuDeptCode, ...recruitReadAllDeptCode, ...chiikikyoseiZenkokuDeptCodes, ...kansashitsuDeptCodes, ...recruitResearchDeptCode);

  if (
    departmentCodeList.includes(departmentCodeOA) ||
    adminUserList.includes(mailAddress) || adminUserChecKTemplateList.includes(mailAddress) ||
    sevenviewOfficerJobCodeArray.includes(jobCategoryCodeOA) ||
    isKentikuKanriDept(departmentCodeOA)|| isQcDept(departmentCodeOA)
  ) {
    return true;
  } else {
    return false;
  }
};

/**
 * ZMチェック
 * @param user
 * @returns
 */
export const isZmCheck = (user: any) => {
  return isZmCheckByElement(user.jobCategoryCodeOA, user.departmentCodeOA);
};

/**
 * ZMチェック(要素)
 * @param jobCategoryCodeOA
 * @param departmentCodeOA
 * @returns
 */
export const isZmCheckByElement = (
  jobCategoryCodeOA: string,
  departmentCodeOA: string
) => {
  const zmJobCode = [JOB_CATEGORY_CODE_ZM, JOB_CATEGORY_CODE_ZM_JOHO];
  const gmDepartmentCode = [okinawaPresidentDeptCode];
  if (
    zmJobCode.includes(jobCategoryCodeOA) ||
    chiikikyoseiZoDeptCodes.includes(departmentCodeOA) ||
    ([JOB_CATEGORY_CODE_GM].includes(jobCategoryCodeOA) &&
      gmDepartmentCode.includes(departmentCodeOA))
  ) {
    return true;
  } else {
    return false;
  }
};

/**
 * DMチェック
 * @param user
 * @returns
 */
export const isDmCheck = (user: any) => {
  return isDmCheckByElement(user.jobCategoryCodeOA);
};

/**
 * DMチェック(要素)
 * @param jobCategoryCodeOA
 * @returns
 */
export const isDmCheckByElement = (jobCategoryCodeOA: string) => {
  const dmJobCode = [JOB_CATEGORY_CODE_DM];
  if (dmJobCode.includes(jobCategoryCodeOA)) {
    return true;
  } else {
    return false;
  }
};

/**
 * OFCチェック
 * @param user
 * @returns
 */
export const isOfcUserCheck = (user: any) => {
  const ofcJobCode = [JOB_CATEGORY_CODE_OFC];
  if (ofcJobCode.includes(user.jobCategoryCodeOA)) {
    return true;
  } else {
    return false;
  }
};

/**
/* OFC・SOFCチェック
 * 
 * @param user 
 * @param tenpoCode 
 * @returns 
 */
export const isOfcCheck = (user: any, tenpoCode: any) => {
  let tenpoCodeSpecialList: any[] = user.tenpoCodeSpecialList;
  if (!tenpoCodeSpecialList) {
    tenpoCodeSpecialList = [];
  }

  if (
    isOfcUserCheck(user) ||
    (isDmCheck(user) && tenpoCodeSpecialList.includes(tenpoCode))
  ) {
    return true;
  } else {
    return false;
  }
};


/**
 * 作業連携チェック
 */
export const isWorkProgress = (user: any, tenpoCode: any) => {
  let tenpoCodeSpecialList: any[] = user.tenpoCodeSpecialList;
  if (!tenpoCodeSpecialList) {
    tenpoCodeSpecialList = [];
  }

  if (
    isOfcUserCheck(user) ||
    (isDmCheck(user) && tenpoCodeSpecialList.includes(tenpoCode))
  ) {
    return true;
  } else {
    return false;
  }
};

/**
 * テンプレート画面表示判定
 */
export const isOpenTemplatePage = (user: any) => {
  if (isZmCheck(user) || isDmCheck(user) || isNationwide(user)) {
    return true;
  } else {
    return false;
  }
};

/**
 * テンプレート_全国チェック判定
 */
export const isNationwide = (user: any) => {
  const opKikakuJohoDeptCodes = [opKikakuDeptCode, opJohoDeptCode, opShienDeptCode];
  if (opKikakuJohoDeptCodes.includes(user.departmentCodeOA) 
      || chiikikyoseiZenkokuDeptCodes.includes(user.departmentCodeOA) 
      || adminUserChecKTemplateList.includes(user.mailAddress)
      || sevenviewOfficerJobCodeArray.includes(user.jobCategoryCodeOA)
    ) {
    return true;
  }
  return false;
};

/**
 * jobCategoryをcodeから取得する
 */
export const getJobCategoryFromCode = (user: any) => {
  if (isOfcUserCheck(user)) {
    return "ofc";
  } else if (isDmCheck(user)) {
    return "dm";
  } else if (isZmCheck(user)) {
    return "zm";
  } else if (isAdminCheck(user)) {
    return "admin-group";
  } else if (isKyoikusuishinShainkenshuDept(user.departmentCodeOA)) {
    return "kyoiku-suishin";
  } else if(isRecruitDept(user.departmentCodeOA, user.jobCategoryCodeOA)){
    return "recruit";
  } else {
    // コードから判定できない場合はユーザ情報のjobCategoryをそのまま返却
    return user.jobCategory;
  }
};

/**
 * 管理者分析の全参照権限
 */
export const hasManagerAnalysisFullReferencePrivileges = (
  user: any
): boolean => {
  return (
    isAdminCheck(user) ||
    isKyoikusuishinShainkenshuDept(user.departmentCodeOA) ||
    isKentikuKanriDept(user.departmentCodeOA)
  );
};
